import React, { useEffect, useState, useMemo } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import "./CancelandRefund.css";
import {
    getGroceryRefundHistoryAPI,
} from "../../../Servicefile/GroceryService.jsx";
import axios from "axios";

const Grocerycancelandrefundpage = () => {
    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    const [filterOrderId, setFilterOrderId] = useState("");
    const [filterName, setFilterName] = useState("");
    const [filterDate, setFilterDate] = useState("");
    const [filterStatus, setFilterStatus] = useState("");

    const [selectedItem, setSelectedItem] = useState(null); // Details modal
    const [showPaymentModal, setShowPaymentModal] = useState(false); // Razorpay simulation modal
    const [itemForPayment, setItemForPayment] = useState(null);
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false); // Refund popup
    const [selectedRefund, setSelectedRefund] = useState(null);

    // Fetch refund history from API
    const fetchRefundHistory =
        async () => {
            setLoading(true);

            setError(null);

            try {
                showLoader();

                const data =
                    await getGroceryRefundHistoryAPI();

                setAllData(
                    data
                );

                setFilteredData(
                    data
                );

            } catch (err) {
                console.error(
                    err
                );

                setError(
                    err?.response?.data
                        ?.message ||
                    err.message ||
                    "Failed to fetch data."
                );

            } finally {
                setLoading(false);

                hideLoader();
            }
        };


    useEffect(() => {
        fetchRefundHistory();
    }, []);

    // Filters
    useEffect(() => {
        let currentData = [...allData];
        if (filterOrderId)
            currentData = currentData.filter((item) =>
                item.userId.toLowerCase().includes(filterOrderId.toLowerCase())
            );
        if (filterName)
            currentData = currentData.filter((item) =>
                item.userName.toLowerCase().includes(filterName.toLowerCase())
            );
        if (filterDate)
            currentData = currentData.filter(
                (item) =>
                    new Date(item.orderDateAndTime).toISOString().split("T")[0] === filterDate
            );

        if (filterStatus)
            currentData = currentData.filter((item) => item.status === filterStatus);

        setFilteredData(currentData);
    }, [allData, filterOrderId, filterName, filterDate, filterStatus]);

    const updateItemStatus = (userId, newStatus) => {
        setAllData((prevData) =>
            prevData.map((item) => (item.userId === userId ? { ...item, status: newStatus } : item))
        );
    };

    // Approve refund: fetch details and show popup
    const handleApprove = async (refundId) => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) throw new Error("Authentication token is missing.");

            const res = await fetch(
                `http://10.10.20.9:6300/Mamaswebsite-0.0.1-Mamaswebsite-0.0.1-SNAPSHOT/refundhistory/get/order/${refundId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!res.ok) throw new Error(`Failed to fetch refund details. Status: ${res.status}`);

            const data = await res.json();
            let refundDetails = null;
            if (data?.refundId) refundDetails = data;
            else if (Array.isArray(data) && data.length > 0) refundDetails = data[0];
            else if (data?.data?.refundId) refundDetails = data.data;
            else throw new Error("Refund details not found in response.");

            setSelectedRefund(refundDetails);
            setIsPopupOpen(true);
        } catch (err) {
            console.error(err);
            alert("Could not fetch refund details.");
        }
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setSelectedRefund(null);
    };

    const handleSaveRefund = async () => {
        if (!selectedRefund || !selectedRefund.transactionId || !selectedRefund.price) {
            alert("Missing transaction ID or amount.");
            return;
        }

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        try {
            const response = await fetch(
                "http://10.10.20.9:6300/Mamaswebsite-0.0.1-Mamaswebsite-0.0.1-SNAPSHOT/api/payments/refund",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        payment_id: selectedRefund.transactionId,
                    }),
                }
            );

            const result = await response.json();
            if (response.ok) {
                alert("✅ Refund submitted successfully!");
                closePopup();
            } else {
                alert("Refund failed: " + (result?.message || "Unknown error"));
            }
        } catch (err) {
            console.error(err);
            alert("Something went wrong.");
        }
    };

    // Razorpay Simulation
    const handleInitiatePayment = (item) => {
        setItemForPayment(item);
        setShowPaymentModal(true);
    };

    const handleConfirmPaymentAndApprove = () => {
        if (!itemForPayment) return;
        setIsProcessingPayment(true);
        setTimeout(() => {
            alert(
                `Simulated Razorpay refund successful for Order ID: ${itemForPayment.userId}. Status updated to Approved.`
            );
            updateItemStatus(itemForPayment.userId, "Approved");
            setShowPaymentModal(false);
            setItemForPayment(null);
            setIsProcessingPayment(false);
        }, 2000);
    };

    const handleCancelPayment = () => {
        setShowPaymentModal(false);
        setItemForPayment(null);
        setIsProcessingPayment(false);
    };

    const openDetailsModal = (item) => setSelectedItem(item);
    const closeDetailsModal = () => setSelectedItem(null);

    const handleClearFilters = () => {
        setFilterOrderId("");
        setFilterName("");
        setFilterDate("");
        setFilterStatus("");
    };

    const handleExport = () => {
        if (filteredData.length === 0) return alert("No data to export.");
        const headers = [
            "Order ID",
            "Name",
            "Request Date",
            "Resolution Date",
            "Request Time",
            "Amount",
            "Transaction ID",
            "Payment Method",
            "Reason",
            "Status",
        ];
        const csvRows = [
            headers.join(","),
            ...filteredData.map((row) =>
                [
                    `"${row.userId}"`,
                    `"${row.userName}"`,
                    `"${new Date(row.cancelledAt).toLocaleDateString()}"`,
                    `"${row.resolutionDate || ""}"`,
                    `"${new Date(row.cancelledAt).toLocaleTimeString()}"`,
                    `"${row.price?.toFixed(2) || 0}"`,
                    `"${row.transactionId}"`,
                    `"Online_Payment"`,
                    `"${row.reason?.replace(/\n/g, " ") || ""}"`,
                    `"${row.status}"`,
                ].join(",")
            ),
        ];
        const csvString = csvRows.join("\n");
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "cancellations_and_refunds.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const uniqueOrderIds = useMemo(
        () => [...new Set(allData.map((item) => item.userId))].sort(),
        [allData]
    );
    const uniqueNames = useMemo(
        () => [...new Set(allData.map((item) => item.userName))].sort(),
        [allData]
    );
    const uniqueStatuses = useMemo(
        () => [...new Set(allData.map((item) => item.status))].sort(),
        [allData]
    );

    const getStatusBadgeClass = (status) => {
        switch (status?.toLowerCase()) {
            case "refunded":
                return "bg-success";
            case "pending":
                return "bg-warning text-dark";
            case "failed":
                return "bg-danger";
            default:
                return "bg-secondary";
        }
    };


    const thStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
        fontWeight: "bold",
        backgroundColor: "#b15cd6",
        color: "white",
    };
    const tdStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
    };
    const inputStyle = {
        width: "100%",
        padding: "8px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        marginTop: "4px",
        backgroundColor: "#f9f9f9",
        fontSize: "15px",
    };
    const filterSelectStyle = {
        backgroundColor: "#b15cd6",
        color: "#fff",
        border: "none",
        height: "35px",
        borderRadius: "4px"
    };

    return (
        <div className="container-fluid d-flex flex-column">
            {/* Filters & Export */}
            <div className="row flex-grow-1" style={{ marginTop: "-20px" }}>
                <div className="col-lg-12 col-12 ps-2 pe-2">
                    <div className="vh-100" style={{ scrollbarWidth: "none", }}>
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-start mb-1 gap-2">
                            <div className="d-flex flex-wrap align-items-center gap-2">
                                {/* <select
                                    value={filterOrderId}
                                    onChange={(e) => setFilterOrderId(e.target.value)}
                                    className="form-select form-select-sm"
                                    style={{ width: "auto", minWidth: "130px" }}
                                >
                                    <option value="">Order ID</option>
                                    {uniqueOrderIds.map((id) => (
                                        <option key={id} value={id}>
                                            {id}
                                        </option>
                                    ))}
                                </select> */}

                                <div style={{ minWidth: "120px" }}>
                                    <input
                                        className="form-control form-control-sm"
                                        type="date"
                                        style={filterSelectStyle}
                                        value={filterDate}
                                        onChange={(e) => setFilterDate(e.target.value)}
                                    />
                                </div>

                                {/* <button onClick={handleClearFilters} className="btn btn-sm btn-outline-secondary ">
                                    Clear
                                </button> */}
                            </div>
                            <button
                                onClick={handleExport}
                                className="btn btn-sm align-self-md-start mt-2 mt-md-0 me-5"
                                style={{ width: "100px", backgroundColor: "#b15cd6", color: "#fff", marginLeft: "-50PX" }}
                            >
                                Export CSV
                            </button>
                            {/* <button onClick={handleExport} style={{ padding: "6px 12px", backgroundColor: "#b15cd6", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>
                                Export CSV
                            </button> */}
                        </div>

                        {/* Table */}
                        {loading && <p className="text-center mt-5">Loading data...</p>}
                        {error && <p className="text-center text-danger mt-5">{error}</p>}
                        {!loading && !error && (
                            <div
                                className="table-responsive shadow-sm roror3"
                                style={{ height: "calc(100vh - 255px)", overflowY: "auto", scrollbarWidth: "none" }}
                            >
                                <table className="table-striped table-bordered table-hover align-middle">
                                    <thead style={{ backgroundColor: "#b15cd6", color: "#fff" }}>
                                        <tr>
                                            <th className="p-2 text-center">SNO</th>
                                            <th className="p-2 text-center">OrderID</th>
                                            <th className="p-2 text-center">TransactionId</th>
                                            <th className="p-2 text-center">Name</th>
                                            <th className="p-2 text-center">RequestDate</th>
                                            <th className="p-2 text-center">RequestTime</th>
                                            <th className="p-2 text-center">Amount</th>
                                            <th className="p-2 text-center">RefundID</th>
                                            <th className="p-2 text-center">Payment</th>
                                            <th className="p-2 text-center">Description</th>
                                            <th className="p-2 text-center">Status</th>
                                            <th className="text-center p-2">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.map((item, index) => (
                                            <tr key={item.refundId}>
                                                <td style={tdStyle}>{index + 1}</td>
                                                <td style={tdStyle}>{item.orderId}</td>
                                                <td style={tdStyle}>{item.paymentId || "—"}</td>
                                                <td style={tdStyle}>{item.userName}</td>
                                                <td style={tdStyle}>
                                                    {item.orderDateAndTime
                                                        ? new Date(item.orderDateAndTime).toLocaleDateString()
                                                        : "—"}
                                                </td>
                                                <td style={tdStyle}>
                                                    {item.orderDateAndTime
                                                        ? new Date(item.orderDateAndTime).toLocaleTimeString()
                                                        : "—"}
                                                </td>
                                                <td style={tdStyle}>₹{Number(item.amountPaid || 0).toFixed(2)}</td>
                                                <td style={tdStyle}>{item.refundId}</td>
                                                <td style={tdStyle}>{item.paymentMethod}</td>
                                                <td style={tdStyle}>{item.cancelReason}</td>
                                                <td style={tdStyle}>
                                                    <span className={`badge ${getStatusBadgeClass(item.orderStatus)}`}>
                                                        {item.orderStatus}
                                                    </span>
                                                </td>
                                                <td className="p-3">
                                                    <button
                                                        className="btn btn-success btn-sm"
                                                        onClick={() => handleApprove(item.refundId)}
                                                    >
                                                        Approve
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>


                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Details Modal */}
            {selectedItem && (
                <div className="modal fade show bg-white" tabIndex={-1} style={{ display: "block" }}>
                    <div className="modal-dialog modal-lg bg-white">
                        <div className="modal-content bg-white border-0">
                            <div className="modal-header">
                                <h5 className="modal-title">Cancellation/Refund Details</h5>
                                <button type="button" className="btn-close" onClick={closeDetailsModal}></button>
                            </div>
                            <div className="modal-body">
                                <p><strong>Order ID:</strong> {selectedItem.userId}</p>
                                <p><strong>Customer Name:</strong> {selectedItem.userName}</p>
                                <p><strong>Request Date:</strong> {selectedItem.requestDate}</p>
                                <p><strong>Request Time:</strong> {selectedItem.requestTime}</p>
                                <p><strong>Amount:</strong> ${selectedItem.amount?.toFixed(2)}</p>
                                <p><strong>Transaction ID:</strong> {selectedItem.transactionId}</p>
                                <p><strong>Payment Method:</strong> {selectedItem.paymentMethod}</p>
                                <p><strong>Proposed Resolution Date:</strong> {selectedItem.resolutionDate}</p>
                                <p className="mb-1"><strong>Reason for Cancellation/Refund:</strong></p>
                                <p className="p-2 bg-light border rounded" style={{ whiteSpace: "pre-line" }}>
                                    {selectedItem.reason}
                                </p>
                                <p><strong>Current Status:</strong>
                                    <span className={`ms-2 badge ${getStatusBadgeClass(selectedItem.status)}`}>
                                        {selectedItem.status}
                                    </span>
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={closeDetailsModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Refund Popup */}
            {isPopupOpen && selectedRefund && (
                <div style={{
                    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                    background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px"
                }}>
                    <div style={{
                        background: "#fff", padding: "30px", borderRadius: "12px", width: "100%", maxWidth: "500px",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.25)", fontFamily: "'Segoe UI', sans-serif"
                    }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
                            <label>Refund ID:<input type="text" value={selectedRefund.refundId || ""} readOnly style={inputStyle} /></label>
                            <label>Order ID:<input type="text" value={selectedRefund.orderId || ""} readOnly style={inputStyle} /></label>
                            <label>User Name:<input type="text" value={selectedRefund.userName || ""} readOnly style={inputStyle} /></label>
                            <label>Price:<input type="text" value={`₹${selectedRefund.price || "0.00"}`} readOnly style={inputStyle} /></label>
                            <label>Cancelled At:<input type="text" value={selectedRefund.cancelledAt ? new Date(selectedRefund.cancelledAt).toLocaleString() : ""} readOnly style={inputStyle} /></label>
                            <label>Transaction ID:<input type="text" value={selectedRefund.transactionId || ""} readOnly style={inputStyle} /></label>
                        </div>
                        <div style={{ textAlign: "center", marginTop: "25px" }}>
                            <button onClick={closePopup} style={{ backgroundColor: "#d63031", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "bold" }}>Close</button>
                            <button onClick={handleSaveRefund} style={{ backgroundColor: "#00b894", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "bold", marginLeft: "10px" }}>Save</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Grocerycancelandrefundpage;
